import { Box } from "@chakra-ui/react";
import PromptTextArea from "./prompt_textarea";
const GenImage = () => {
  return (
    <Box position="relative" bgColor="#0C0B10" pl="5px" pr="5px">
      <PromptTextArea />
    </Box>
  )
}

export default GenImage